import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';

import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { UitkToolbar } from 'uitk-react-toolbar';

const LinkTracked = ClickTracker(UitkLink);

export interface PriceBreakDownDialogProps {
  id: string;
  layerId: string | number;
  header: string;
  childContent: React.ReactNode;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
}
@inject('routeStore', 'analytics')
@observer
export class PriceBreakDownDialog extends React.Component<PriceBreakDownDialogProps> {
  private onDismiss = () => {
    this.props.routeStore.goBack();
  };

  public render() {
    const { id, layerId, header, childContent, routeStore, analytics } = this.props;
    const dialogId = `price-breakdown-dialog-${layerId}`;

    if (!header || !childContent) {
      return null;
    }

    const param = id === 'infosite-room-info-dialog-ratePlans' ? { pwaDialogNested: dialogId } : { pwaDialog: dialogId };
    const trackingRfrr = id === 'infosite-room-ratePlans' ? 'RoomsAndRates.PriceDetailDialog' : 'RoomInfo.PriceDetailDialog';
    const query = routeStore.mergeQueryString(routeStore.search, param);
    const toolbarAnalytics = analytics.setupTracker(trackingRfrr, 'Close price details dialog');
    const routeStoreGoBack = () => routeStore.goBack();

    return (
      <>
        <LinkTracked
          className="all-y-padding-two"
          linkName="Open price details dialog"
          rfrr={trackingRfrr}
          iconPos={UitkLinkAlign.RIGHT}
          align={UitkLinkAlign.RIGHT}
        >
          <Link to={{ pathname: routeStore.pathname, search: query }}>
            {header}
            <UitkIcon name="navigate_next" size={UitkIconSize.SMALL} />
          </Link>
        </LinkTracked>
        <QueryRoute query={param}>
          <Layer id={`pricebreakdown-layer-${layerId}`} onDismiss={routeStoreGoBack}>
            <UitkFullscreenDialog dialogShow={true}>
              <UitkToolbar analytics={toolbarAnalytics} header={header} action={this.onDismiss} iconLabel="close.dialog" />
              <UitkDialogContent zeroPadding={true}>{childContent}</UitkDialogContent>
            </UitkFullscreenDialog>
          </Layer>
        </QueryRoute>
      </>
    );
  }
}
